import React, { useState } from "react";
import { S, todayStr } from "./theme";
import DateBox from "./DateBox";

const blank = (leadId, user) => ({
  title: "",
  leadId: leadId || "",
  dueDate: todayStr(),
  priority: "Medium",
  notes: "",
  assignedToUid: user?.uid || "",
  assignedToName: user?.name || user?.email || "",
});

export default function TaskModal({ task, leads, defaultLeadId, user, salesUsers, onSave, onClose, onDelete }) {
  const [form, setForm] = useState(task ? { ...blank(defaultLeadId, user), ...task } : blank(defaultLeadId, user));
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const handleSave = async () => {
    if (!form.title.trim()) { setError("Task title is required."); return; }
    setSaving(true);
    setError("");
    try {
      await onSave(form);
      onClose();
    } catch (e) {
      setError("Save failed: " + e.message);
    }
    setSaving(false);
  };

  return (
    <div style={S.modalOverlay} onClick={onClose}>
      <div style={S.modalBox} onClick={(e) => e.stopPropagation()}>
        <div style={S.header}>
          <div style={S.title}>{task ? "Edit Task" : "New Task"}</div>
          <button style={S.btnSmall} onClick={onClose}>✕ Close</button>
        </div>

        {error && <div style={{ ...S.msg, borderColor: "#f87171", color: "#f87171" }}>{error}</div>}

        <div style={{ marginBottom: 14 }}>
          <label style={S.label}>Title *</label>
          <input style={S.input} value={form.title} onChange={(e) => set("title", e.target.value)} placeholder="e.g. Call President about pricing" />
        </div>

        <div style={{ marginBottom: 14 }}>
          <label style={S.label}>Linked Lead (optional)</label>
          <select style={S.select} value={form.leadId} onChange={(e) => set("leadId", e.target.value)}>
            <option value="">— None —</option>
            {leads.map((l) => <option key={l.id} value={l.id}>{l.societyName}</option>)}
          </select>
        </div>

        <div style={S.formGrid}>
          <div>
            <label style={S.label}>Due Date</label>
            <DateBox value={form.dueDate} onChange={(v) => set("dueDate", v)} />
          </div>
          <div>
            <label style={S.label}>Priority</label>
            <select style={S.select} value={form.priority} onChange={(e) => set("priority", e.target.value)}>
              <option>High</option><option>Medium</option><option>Low</option>
            </select>
          </div>
        </div>

        {salesUsers && salesUsers.length > 0 && (
          <div style={{ marginBottom: 14 }}>
            <label style={S.label}>Assigned To</label>
            <select
              style={S.select}
              value={form.assignedToUid}
              onChange={(e) => {
                const rep = salesUsers.find((u) => u.id === e.target.value);
                set("assignedToUid", e.target.value);
                set("assignedToName", rep ? (rep.name || rep.email) : "");
              }}
            >
              {salesUsers.map((u) => <option key={u.id} value={u.id}>{u.name || u.email}</option>)}
            </select>
          </div>
        )}

        <div style={{ marginBottom: 14 }}>
          <label style={S.label}>Notes</label>
          <textarea style={S.textarea} rows={2} value={form.notes} onChange={(e) => set("notes", e.target.value)} />
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 16 }}>
          <div>
            {task && onDelete && (
              <button style={S.btnRed} onClick={() => onDelete(task.id)}>Delete Task</button>
            )}
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <button style={S.btnGray} onClick={onClose}>Cancel</button>
            <button style={S.btnBlue} onClick={handleSave} disabled={saving}>{saving ? "Saving…" : "Save Task"}</button>
          </div>
        </div>
      </div>
    </div>
  );
}